import React, { useState } from "react";
import ColorDisplay from "./ColorDisplay";
import ColorGradient from "./ColorGradient";
import ColorSelector from "./ColorSelector";
import ColorInput from "./ColorInput";

const ColorRow = ({ rowLabel, pickedColor }) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  const onDisplayColorPick = (showColorPicker) => {
    setShowColorPicker(showColorPicker);
  };

  // There is a bug in the current npm color package so this function will round each hsl
  const roundHsl = (pickedColor) => {
    const rounded = pickedColor.hsl().color.map(function (hslValue, index) {
      return index === 0 ? hslValue.toFixed(2) : hslValue.toFixed(2) + "%";
    });

    return "hsl(" + rounded.join(", ") + ")";
  };

  return (
    <div className="color-row">
      <div className="color-row-label">{rowLabel}</div>
      <div className="color-selector-display">
        {showColorPicker ? (
          <ColorSelector
            pickedColor={pickedColor}
            rowLabel={rowLabel}
            setDisplayColorSelector={onDisplayColorPick}
          />
        ) : null}
        <ColorDisplay
          pickedColor={pickedColor}
          rowLabel={rowLabel}
          setDisplayColorSelector={onDisplayColorPick}
        />
      </div>
      <div className="color-row-input">
        <ColorInput label="HEX" rowLabel={rowLabel} pickedColor={pickedColor.hex()} />
        <ColorInput label="RGB" rowLabel={rowLabel} pickedColor={pickedColor.rgb().string()} />
        <ColorInput label="HSL" rowLabel={rowLabel} pickedColor={roundHsl(pickedColor)} />
      </div>
      <ColorGradient
        pickedColor={pickedColor}
        setShowColorPicker={setShowColorPicker}
        rowLabel={rowLabel}
      />
    </div>
  );
};
export default ColorRow;
